<template>
  <div id="app">
    <router-view />
    <Footers v-if="foot"></Footers>
  </div>
</template>

<script>
import Footers from './components/footers.vue'
import './static/css/reset.css'
export default {
  name: 'App',
  components: { Footers },
  data () {
    return {
      foot: true
    }
  },
  created () {
    let link = document.querySelector('link[rel*="icon"]');
    // if () {
    // link.href =
    //   "https://www.chuangyouhy.com/%E4%B8%87%E5%9F%9F%E5%A4%A9%E6%B8%B8.png";
    // }
  },
  mounted () {
    if (sessionStorage.getItem("blu") === "1") {
      this.foot = false
      this.$router.push('/404');
    } else {
      return
    }
  }
}
</script>

<style>
div {
  cursor: default;
}
</style>



// WEBPACK FOOTER //
// src/App.vue